/*
 Initial state and properties
 */
 export const initialState = {
    mode:"POST",
    unidadIdSelected:0,
    defaultDataUnidad:{}
 }
 /*
  Action types
  */
 export const SET_MODE = 'SET_MODE'
 export const SET_UNIDAD_ID = 'SET_UNIDAD_ID'
 export const SET_DEFAULT_DATA = 'SET_DEFAULT_DATA'
 /*
  Arrow function for change state
  */
 export const setMode = (payload) => ({
   type: SET_MODE,
   payload,
 });
 export const setUnidadId = (payload) => ({
  type: SET_UNIDAD_ID,
  payload,
})
export const setDefaultDataUnidad = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
})
 /*
  Reducer to describe how the state changed
  */
 export default function Reducer(state = initialState, { type, payload }) {
   switch (type) {
     case SET_MODE:
       return {
         ...state,
         mode: payload,
       }
       case SET_UNIDAD_ID:
        return {
          ...state,
          unidadIdSelected: payload,
        }
        case SET_DEFAULT_DATA:
          return {
            ...state,
            defaultDataUnidad: payload,
          }
     default:
       return state
   }
 }
 